var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtmlFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_172067",
    "data-name": "Group 172067",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.4,
    height: 18,
    viewBox: "0 0 14.4 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-pdf-645094",
    d: "M177.736,51.165v1.8h-.9v-1.8h-2.7a.9.9,0,0,1-.9-.9v-2.7h-9v5.4h-.9v-5.4a.9.9,0,0,1,.9-.9h9a.9.9,0,0,1,.639.261l3.6,3.6a.9.9,0,0,1,.261.639Zm-.9,12.6h-12.6v-.9h-.9v.9a.9.9,0,0,0,.9.9h12.6a.9.9,0,0,0,.9-.9v-.9h-.9Z",
    transform: "translate(-163.336 -46.666)",
    fill: "#203662"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21008",
    "data-name": "Path 21008",
    d: "M26.9,14.6V11H26v4.5h2.7v-.9Z",
    transform: "translate(-14.3 -2)",
    fill: "#203662"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21009",
    "data-name": "Path 21009",
    d: "M20.15,11h-.9l-.675,1.8L17.9,11H17v4.5h.9V12.35l.675,1.8.675-1.8V15.5h.9Z",
    transform: "translate(-9.351 -2)",
    fill: "#203662"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21010",
    "data-name": "Path 21010",
    d: "M9,11.9h.9v3.6h.9V11.9h.9V11H9Z",
    transform: "translate(-4.95 -2)",
    fill: "#203662"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21011",
    "data-name": "Path 21011",
    d: "M2.25,11v1.8H.9V11H0v4.5H.9V13.7H2.25v1.8h.9V11Z",
    transform: "translate(0 -2)",
    fill: "#203662"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlFile);
export default __webpack_public_path__ + "static/media/HTMLFile.b884e60da8bc84ad0d7241e1554b8376.svg";
export { ForwardRef as ReactComponent };